/** Spanish UI strings for the "Solicitudes de matrícula" module (Fase 1). Code stays in English; copy stays in Spanish. */
const S = {
	title: "Matrículas",   // antes "Estudiantes por Aprobar" (Esteban, 2026-09-24)
	newRequest: "Nueva Solicitud",
	newRemote: "Digital",
	newPresencial: "En Persona",
	reviewers: "Revisoras",
	search: "Buscar por nombre, identificación o teléfono",
	tabs: { drafts: "Borradores", submitted: "Por revisar", returned: "Rechazadas", pendingPayment: "Pendiente Pago", enrolled: "Finalizadas" },
	onlyMine: "Solo asignadas a mí",
	draftsHint: "Un borrador solo lo ves tú y tu Dirección de Ventas. El que nadie retome se borra solo a las 48 horas.",
	empty: "No hay solicitudes en esta bandeja.",
	col: { id: "#", student: "Alumno", course: "Curso / Horario", schedule: "Horario", advisors: "Asesoras", mode: "Tipo", status: "Estado", assignedTo: "Admisiones", createdBy: "Envió", caja: "Cajera", updatedAt: "Actualizada" },
	mode: "Tipo de Matrícula",
	modeRemote: "Digital",   // antes "Remota" (Esteban, 2026-09-23)
	modePresencial: "En Persona",
	student: "Alumno",
	existingStudent: "Alumno Actual o Reingreso",
	newStudent: "Alumno nuevo",
	searchStudent: "Buscar por nombre, identificación, correo o teléfono",
	noStudents: "Sin resultados.",
	selectedStudent: "Alumno seleccionado",
	changeStudent: "Cambiar",
	duplicatesWarning: "Ya existen alumnos con esta identificación o correo. Revisa que no sea un reingreso:",
	useExisting: "Usar este alumno",
	fields: {
		firstName: "Nombres", lastName: "Apellidos", identificationTypeId: "Tipo de identificación", identificationCode: "Identificación",
		birthday: "Fecha de nacimiento", genderId: "Género", nationalityId: "Nacionalidad", countryId: "País", stateId: "Estado / Departamento", cityId: "Ciudad",
		email: "Correo", phone1: "Teléfono", phone2: "Teléfono 2", address: "Dirección", zipcode: "Código postal", academicDegreeId: "Último grado de estudios",
		lastSchoolName: "Última escuela", currentOccupation: "Ocupación", observations: "Observaciones", tagIds: "Etiquetas", contacts: "Contactos de emergencia",
		contactName: "Nombre", contactRelation: "Parentesco", contactMedia: "Teléfono / medio", facebook: "Facebook", instagram: "Instagram"
	},
	addContact: "Agregar contacto",
	select: "Seleccione...",
	schedule: "Horarios a Matricular",
	scheduleHint: "Solo aparecen los horarios que WAPP permite para este alumno (nuevo ingreso: hasta 15 días de iniciado; reingreso al mismo curso: horarios activos).",
	searchSchedules: "Buscar por curso, módulo, horario o código",
	noSchedules: "No hay horarios disponibles.",
	selectedSchedule: "Horario elegido",
	advisors: "Asesoras",
	notes: "Nota de Matrícula",
	notesPlaceholder: "Promoción, acuerdo con el alumno, contexto de la venta...",
	commercialTerms: "Condiciones comerciales",
	commercialTermsPlaceholder: "Descuentos o condiciones pactadas (texto libre por ahora).",
	payment: "Pago",
	paymentType: "Forma de pago",
	amount: "Monto",
	paidAt: "Fecha de pago",
	recipientAccount: "Cuenta receptora",
	paymentMethod: "Método de pago",
	reference: "Referencia",
	presencialPaymentHint: "El cliente paga en Caja. Indica el monto acordado para que Caja lo tenga listo.",
	documents: "Documentos",
	contract: "Contrato",
	contractRegenerate: "Generar de nuevo",
	contractView: "Ver contrato",
	contractViewSigned: "Ver firmado",
	contractViewGenerated: "Ver generado",
	contractUploadSigned: "Subir firmado",
	contractReplaceSigned: "Reemplazar firmado",
	contractSigned: "Firmado",
	documentsHint: "Puede adjuntar varios archivos (imagen o PDF).",
	docIdStudent: "Identificación del alumno",
	docIdGuardian: "Identificación del padre, madre o tutor",
	docReceipt: "Comprobante de pago",
	docMissing: "Falta",
	docOptional: "Opcional · si paga en efectivo en caja, déjalo vacío",
	paymentNotes: "Nota del pago",
	paymentNotesPlaceholder: "Lo que caja necesita saber del pago",
	documentType: "Tipo",
	upload: "Subir",
	pendingUploads: "Se subirán al guardar",
	download: "Ver",
	remove: "Quitar",
	comments: "Comentarios",
	addComment: "Agregar comentario",
	commentPlaceholder: "Escribe un comentario...",
	validationTitle: "Falta para poder enviar / aprobar:",
	saveDraft: "Guardar borrador",
	save: "Guardar cambios",
	submit: "Enviar a revisión",
	submitPresencial: "Guardar y matricular",
	approve: "Aprobar y matricular",
	approveShort: "Aprobar",
	returnToSales: "Rechazar",
	returnPrompt: "Rechazar solicitud",
	returnPlaceholder: "Qué falta o qué hay que corregir",
	returnRequired: "Escribe qué hay que corregir.",
	reassign: "Reasignar",
	reassignPrompt: "Reasignar solicitud",
	reassignTo: "Pasársela a",
	reassignPlaceholder: "Qué necesitas que revise",
	commentOptional: "Comentario (opcional)",
	reassigned: "Solicitud reasignada.",
	edit: "Editar",
	moreActions: "Más acciones",
	confirm: "Confirmar",
	back: "Volver",
	saving: "Guardando...",
	saved: "Solicitud guardada.",
	submitted: "Solicitud enviada a revisión.",
	approved: "Listo: el alumno queda enrolado. Cuando Caja procese el pago pasa a inscrito.",
	returned: "Rechazada: vuelve a la supervisora.",
	createdBy: "Creada por",
	assignedTo: "Asignada a",
	submittedAt: "Enviada",
	reviewedBy: "Revisada por",
	enrollmentCreated: "Matrícula",
	paymentIntentCreated: "Ticket de Caja",
	summary: "Resumen",
	detailsTitle: "Solicitud de matrícula",
	requestNumber: "Nº",
	submittedAtShort: "enviada",
	subscription: "Inscripción",
	monthly: "Mensualidad",
	free: "Gratis",
	clientOnTheWay: "El cliente va en camino a Caja",
	whatToFix: "Qué corregir",
	commentAdded: "Comentario agregado.",
	commentsGoToProfile: "Todo este movimiento queda también en el Historial de Perfil del alumno.",
	approvingIn: (segundos: number) => `Matriculando en ${segundos}...`,
	approvingHint: "Todavía puedes deshacer.",
	undo: "Deshacer",
	returnedByCaja: "Rechazada por Caja",
	resendToCaja: "Enviar a Caja",
	resendPrompt: "Enviar comprobante nuevo a Caja",
	newReceipt: "Comprobante nuevo",
	attachReceipt: "Adjuntar comprobante",
	commentForCaja: "Comentario para Caja",
	resendPlaceholder: "Qué cambió o qué debe saber Caja",
	docRejected: "Rechazado",
	confirmResendCaja: "¿Mandar el comprobante nuevo a Caja?",
	resentToCaja: "Comprobante enviado otra vez a Caja.",
	unassigned: "Sin asignar",
	none: "-",
	reviewersTitle: "Quién revisa, por turno",
	reviewersHint: "Las solicitudes digitales se reparten en orden entre las revisoras activas de este plantel. Desactiva a quien esté de vacaciones o ya no revise.",
	reviewersPool: "En rotación",
	reviewersCandidates: "Disponibles para agregar",
	reviewersAssigned: "asignadas",
	activate: "Activar",
	deactivate: "Pausar",
	add: "Agregar",
	noCandidates: "Todas las asesoras de Admisiones del plantel ya están en la rotación.",
	fileTooBig: "El archivo supera 10 MB.",
	confirmApprove: "Se creará el alumno (si es nuevo), se matriculará en el horario elegido y Caja recibirá el pago por aplicar. ¿Continuar?",
	confirmSubmit: "¿Enviar la solicitud a revisión?",
	confirmPresencial: "Se matriculará al alumno de inmediato y Caja recibirá el aviso de cliente en camino. ¿Continuar?",
	confirmDirectaDigital: "Se matriculará al alumno de inmediato y Caja recibirá el comprobante para procesarlo. ¿Continuar?",
	studentProfileHint: "El alumno queda visible en Alumnos con su perfil, documentos e historial.",
	perPage: "por página",
	of: "de"
};

export default S;
